<template>
  <v-dialog v-model="dialog2" persistent width="950">
    <v-card class="p-0">
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>edit</v-icon>
          Modificar registro
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md style="min-width: 100%">
            <v-layout wrap row>
              <v-flex xs12 md6>
                <v-text-field
                  label="Fecha de ejecución"
                  v-model="form.fecha_ejecucion"
                  :rules="$validate(['required'])"
                  @input="obtenerGestion()"
                  required
                  type="date"
                  outline
                  disabled
                  success
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Gestión"
                  v-model="form.gestion"
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  disabled
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  :items="lista_cargos"
                  item-text="cargo"
                  item-value="id_cargo"
                  label="Seleccione el cargo"
                  @input="cargarHaber()"
                  v-model="form.id_cargo"
                  outline
                  success
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Porcentaje de incremento (%)"
                  v-model="form.porcentaje"
                  :rules="$validate(['required'])"
                  required
                  @input="cargarHaber()"
                  type="number"
                  outline
                  success
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-if="form.id_cargo"
                  label="Haber básico actual"
                  v-model="form.haber_basico_actual"
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-if="form.id_cargo && form.haber_basico_actual"
                  label="Haber básico incrementado"
                  v-model="form.haber_basico_incrementado"
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                  disabled
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            @click="modificarIncremento()"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
  
  <script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog2: false,
      form: {},
      valid: false,
      loading: false,
      lista_cargos: [],
      incremento_salarial_detalles: [],
      id_incremento_salarial: null,
      headers_detalles: [
        { text: "Cargo", value: "cargo", align: "center" },
        { text: "Porcentage", value: "porcentage", align: "center" },
        {
          text: "Haber básico actual",
          value: "haber_basico_actual",
          align: "center",
        },
        {
          text: "Haber básico incrementado",
          value: "haber_basico_incrementado",
          align: "center",
        },
        { text: this.$t("common.actions"), sortable: false, align: "center" },
      ],
    };
  },
  mounted() {
    this.$bus.$on("openDialogActualizarIncrementoSalarial", async (item) => {
      this.form = item;
      await this.cargarCargos();
      this.dialog2 = true;
    });
  },
  methods: {
    close() {
      this.form = {};
      this.loading = false;
      this.dialog2 = false;
      console.log("esther...");
      this.$bus.$emit("closeDialogIncrementoDetalle");
    },

    async cargarCargos() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                  query {
                      runQuery(consulta:"select * from movilidad.v_item_cargo"){
                          respuesta
                      }
                      }
                  `,
        });
        this.lista_cargos = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },

    async obtenerGestion() {
      try {
        if (
          this.form.fecha_ejecucion &&
          this.form.fecha_ejecucion.length == 5
        ) {
        }
      } catch (error) {
        console.log(error);
      }
    },

    async modificarIncremento() {
      try {
        this.loading = true;
        if (this.$refs.form.validate()) {
          let usuario = this.$storage.get("user");
          let decimal_haber_nuevo="";
          let nuevo_haber=(this.form.haber_basico_incrementado+"").split('.')
          if (nuevo_haber[1]) {
            decimal_haber_nuevo=nuevo_haber[1]
          }
          let nuevo_haber_modificado=nuevo_haber[0]+","+decimal_haber_nuevo
          //(nuevo_haber[1]) ? nuevo_haber[1]):"00")
        
          //almacenando la modificacion del detalle
          let rpta = await this.$service.graphql({
            query: `
                            query{
                              runQuery(consulta:"select movilidad.fn_actualiza_incremento_salarial(${parseInt(
                                this.form.id_incremento_salarial_detalle
                              )},${parseInt(this.form.id_cargo)},'${
                                nuevo_haber_modificado
            }','${this.form.porcentaje}',${usuario.id})"){
                              respuesta
                              }
                            }
                          `,
          });
          rpta = rpta.runQuery.respuesta[0].fn_actualiza_incremento_salarial;
          let resps = rpta.split("|");
          if (resps[0] == "1") {
            //modificando la cabecera:
            let respuesta = await this.$service.graphql({
              query: `
                            query{
                              runQuery(consulta:"select movilidad.fn_actualiza_incremento_salarial_cabecera(${parseInt(
                                this.form.id_incremento_salarial
                              )},${parseInt(this.form.gestion)},'${
                this.form.fecha_ejecucion
              }',${usuario.id})"){
                              respuesta
                              }
                            }
                          `,
            });
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_actualiza_incremento_salarial_cabecera;
            let resps1 = respuesta.split("|");
            if (resps1[0] == "1") {
              this.close();
              this.form.id_cargo = null;
              this.form.porcentaje = null;
              this.form.haber_basico_actual = null;
              this.form.haber_basico_incrementado = null;
              this.loading = false;
              this.$alert("Modificación exitosa");
            }
          } else {
            this.$alert(resps[1]);
          }
        }
      } catch (error) {
        console.log(error);
      }
    
    },
    async cargarHaber() {
      try {
        let nuevo_haber;
        if (this.form.id_cargo) {
          const haber_actual = this.lista_cargos.find(
            (fruta) => fruta.id_cargo == parseInt(this.form.id_cargo)
          ).sueldo;
          this.form.haber_basico_actual = parseFloat(
            haber_actual.replace(/\./g, "").replace(/\,/g, ".")
          );
        }
        if (this.form.haber_basico_actual && this.form.porcentaje) {
    
          nuevo_haber =
            (this.form.porcentaje / 100) * this.form.haber_basico_actual +
            this.form.haber_basico_actual;
          this.form.haber_basico_incrementado = nuevo_haber;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
  
  <style>
</style>
  


// WEBPACK FOOTER //
// src/components/admin/incremento_salarial/dialogs/ModificarIncrementoDetalle.vue